import { render, staticRenderFns } from "./ModalTip.vue?vue&type=template&id=0e4916d2&scoped=true"
import script from "./ModalTip.vue?vue&type=script&lang=js"
export * from "./ModalTip.vue?vue&type=script&lang=js"
import style0 from "./ModalTip.vue?vue&type=style&index=0&id=0e4916d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4916d2",
  null
  
)

export default component.exports